import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: "100vh",
        background: "#080d16",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        fontFamily: "'Sora', sans-serif",
        textAlign: "center",
        padding: "0 24px",
      }}>
        <span style={{ fontWeight: 700, fontSize: "1rem", color: "#fff", letterSpacing: "-0.01em" }}>
          Propspector.
        </span>
        <h1 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#fff", margin: "8px 0 0" }}>
          Something went wrong
        </h1>
        <p style={{ fontSize: "0.875rem", color: "#64748b", margin: 0 }}>
          Please refresh to continue
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 8,
            padding: "11px 28px",
            background: "rgba(0,229,255,0.1)",
            color: "#00e5ff",
            border: "1px solid rgba(0,229,255,0.35)",
            borderRadius: 8,
            fontSize: "0.875rem",
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "'Sora', sans-serif",
          }}
        >
          Refresh
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
